import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';
import {
    GateType,
    gateTypeSchema,
} from 'app/agriculture/queries/entities/types/infrastructure/GateType';

export interface Gate extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    gateType: GateType;

    geometry: PointGeometry;
}

export const gateSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    gateType: gateTypeSchema,

    geometry: pointGeometrySchema,
});

export const mockGate = ({
    id = 'aacd9be0-39dc-4e9d-ba38-5a8c96b315a9',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Gate Name',
    gateType = 'Property/Main',

    geometry = mockPointGeometry(),
}: Partial<Gate> = {}): Gate => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,
    gateType,

    geometry,
});
